import { render, staticRenderFns } from "./CAxACGxMemoryPage.vue?vue&type=template&id=9449225c"
import script from "./CAxACGxMemoryPage.vue?vue&type=script&lang=js"
export * from "./CAxACGxMemoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports